
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "loginWithGoogle",
      resolverType: "mutation",
      routePath: "/loginWithGoogle",
      httpMethod: "POST",
    });
  